<i18n>
[
    "reviews__customerPhotos--label",
]
</i18n>

<template>
    <div class="c-pdp-review-images-tray">
        <div class="c-pdp-review-images-tray__header u-spacer--1pt5">
            <div class="c-pdp-review-images-tray__header-text">
                <span class="o-text--caption">
                    {{ t('reviews__customerPhotos--label') }} ({{ `${showingNumberOfImages}/${imageCount}` }})
                </span>
            </div>
        </div>
        <Carousel
            class="c-pdp-review-images-tray__carousel"
            :carouselItems="reviews"
            :name="'CUSTOMER-REVIEW-IMAGES-TRAY'"
            :carouselItemUniqueKey="carouselItemUniqueKey"
            :desktopSlideSize="4"
            :mediumSlideSize="4"
            :mobileSlideSize="2"
            :mobilePeekPercent="50"
            :mediumPeekPercent="0"
            :noContainerMargin="true"
            :translucentButtons="false"
            :lightButtons="false"
            :catalogResponseId="null"
            :resetOnResize="true"
            :analyticsType="null"
        >
            <template
                v-for="(review, index) in reviews"
                :key="getCarouselSlotName(review, carouselItemUniqueKey, index)"
                #[getCarouselSlotName(review,carouselItemUniqueKey,index)]
            >
                <UrbnModalLauncher
                    :modalOptions="{
                        ...pdpReviewsCarouselImageModal,
                        props: { reviewId: review.id },
                    }"
                    type="link"
                    class="c-pdp-review-images-tray__link"
                >
                    <LazyLoad v-slot="{ hasEnteredViewport }">
                        <LazyImage
                            v-if="hasEnteredViewport"
                            :imgSrc="imageUrl(review.photos[0])"
                            :title="title"
                            :shouldDisplayImage="hasEnteredViewport"
                            :fadeInAfterLoaded="true"
                            class="c-pdp-review-images-tray__image"
                        />
                    </LazyLoad>
                </UrbnModalLauncher>
            </template>
        </Carousel>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useState } from '~coreModules/core/js/composables/vuexHelpers';

import { getCarouselSlotName } from '~coreModules/core/js/carousel-utils';
import { getProductModuleNameFromRoute } from '~coreRoutes/product/js/product-utils';

import { IMAGE_PRESETS } from '~modules/core/js/constants';
import { MODALS } from '~modules/modals/js/modal-constants';

import Carousel from '~coreModules/core/components/ui/Carousel.vue';
import LazyLoad from '~coreModules/core/components/ui/LazyLoad.vue';
import LazyImage from '~coreModules/core/components/ui/LazyImage.vue';
import UrbnModalLauncher from '~coreModules/modals/components/UrbnModalLauncher.vue';

// NU_TODO: https://urbnit.atlassian.net/browse/TYP-26682
// Remove below when we update to vue-eslint-parser v9.0.0 or later
/* eslint-disable vue/valid-define-props */
const props = defineProps({
    maxDisplayCount: {
        type: Number,
        default: 4,
    },
});

const { t } = useI18n();
const route = useRoute();
const productModuleName = computed(() => getProductModuleNameFromRoute(route));

const {
    imageCount,
    reviews,
} = useState(productModuleName.value, {
    imageCount: state => state.productDetails?.reviewSummary?.imageCount || 0,
    reviews: state => state.reviews?.imageOnlyReviews?.slice(0, props.maxDisplayCount),
});

const pdpReviewsCarouselImageModal = MODALS.pdpReviewsCarousel;
const carouselItemUniqueKey = 'id';
const imagePreset = IMAGE_PRESETS.ugc.square;

const showingNumberOfImages = computed(() => ((imageCount?.value || 0) > 4 ? props.maxDisplayCount : imageCount.value));

function imageUrl(url) {
    return `${url}?${imagePreset}`;
}

</script>

<style lang="scss">
    .c-pdp-review-images-tray {
        margin-bottom: $nu-spacer-5;

        &__header {
            padding: 0 $nu-spacer-2;
            display: flex;
            justify-content: space-between;

            @include breakpoint(medium) {
                padding: 0;
            }
        }

        &__promo-icon {
            margin-right: $nu-spacer-1;
            vertical-align: middle;
        }
    }
</style>
